module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAA3NCSVQICAjb4U/gAAAAX0lEQVRIiWPsYBBloCVgYWBgMKxyQhM937YPzsaUJagAWZYJq7WGVU5YzSVSAbIsdgtwOY0kBRBZfBZQBYxaMAIsYBzNyYRkR3PyqAWjFowWFUTIjhYVoxYMAQtonpMBzIg2to0F2yoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wall01.png
// module id = IPdy
// module chunks = 1